<template>
  <div class="app-container">
    <ActivateLowLevelStepBar :desc="$t('step_4_title')" health="100" />
    <SetPassword
      v-if="showHistory"
      :mycode="code"
      :err="err"
      :is-err="isErr"
      :is-set-password="isSetPassword"
      :title="crrTitel"
      @func1="getPassword1"
      @func2="getPassword2"
    />
    <PayLoading :context="$t('passWordWaitText')" :is-show="isShow" />
  </div>
</template>

<script>
import ActivateLowLevelStepBar from '@/components/ActivateLowLevelStepBar'
import SetPassword from '@/views/ActivateLowLevelStep4/components/SetPassword'
import {
  setUpPayPassword,
  active,
  setTempPayPassword
} from '@/api/activateLowLevelStep'
import PayLoading from '@/components/PayLoading'
import { getCertificateLevel } from '@/store/modules/common/types'
import { setTransactionPassMd5 } from '@/utils/safe'

export default {
  name: 'ActivateLowLevelStep4',
  components: {
    SetPassword,
    PayLoading,
    ActivateLowLevelStepBar
  },
  data () {
    return {
      err: '',
      isErr: false,
      isSetPassword: true,
      code: '',
      password: '',
      crrTitel: this.$t('setPassword'),
      isShow: false,
      showHistory: true
    }
  },
  activated () {
    this.showHistory = true
  },
  methods: {
    // 激活用户
    active () {
      active()
        .then(() => {
          return this.$store.dispatch(getCertificateLevel)
        })
        .then(() => {
          this.showHistory = false
          this.$router.replace({
            name: 'Home'
          })
        })
    },
    // 设置支付密码
    getPassword1 (data) {
      this.code = data
      this.password = data
      this.$nextTick(() => {
        this.code = ''
        this.isSetPassword = false
        this.crrTitel = this.$t('confirmPassword')
      })
    },
    // 确认密码
    async getPassword2 (data) {
      this.code = data
      if (this.password === data) {
        this.isShow = true
        this.isErr = false
        const flag = this.$route.query.applyAuditFlag // flag判断是不是点击人工审核
        const api = flag ? setTempPayPassword : setUpPayPassword
        try {
          await api({ password: setTransactionPassMd5(data) })
          if (flag) {
            await this.$store.dispatch(getCertificateLevel)
            this.$router.replace({
              name: 'Home'
            })
          } else {
            this.active()
          }
          this.code = ''
          this.showHistory = false
        } catch (e) {
          this.showHistory = true
        } finally {
          this.isShow = false
        }
      } else {
        this.$nextTick(() => {
          this.code = ''
          this.isErr = true
          this.err = this.$t('passwordAndConfirm') // 再次输入支付密码不一致，请重试
        })
      }
    }
  }
}
</script>

<style lang='scss' scoped>
</style>
